var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{staticClass:"bar",attrs:{"value":_vm.progress,"height":"65","width":"100%","background-color":"#fff","color":_vm.barColor}},[_c('span',{staticClass:"bar__label d-flex justify-center align-center"},[_vm._v(_vm._s(_vm.level))])])
}
var staticRenderFns = []

export { render, staticRenderFns }